import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectPropertyListModel } from "../../services/properties-data-service/Models";
import PropertiesDataService from "../../services/properties-data-service/PropertiesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectPropertyListsQueryParams = {
    groupID: number, 
    eLynxObject: IeLynxObject
} & BaseUseQueryParameters<IObjectPropertyListModel>;

export function useObjectPropertyLists(params: UseObjectPropertyListsQueryParams) {
    return useQuery<IObjectPropertyListModel, RestError>(
        keys.propertyLists(params.groupID, params.eLynxObject),
        ({ signal }) => {
            return PropertiesDataService.getPropertyLists(params.groupID, params.eLynxObject, signal);
        },
        { 
            enabled: !(params.enabled === false) && (params.eLynxObject.objectType === eLynxObjectTypeEnum.Device || params.eLynxObject.objectType === eLynxObjectTypeEnum.Tank),
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false
        }
    );
}
